import actionTypes from 'constants/actionTypes'

interface PermissionsVisibilityAction {
  type: string
}

export default (state = false, action: PermissionsVisibilityAction): boolean => {
  switch (action.type) {
    case actionTypes.PERMISSIONS.TOGGLE:
      if (state) return false
      return true
  }
  return state
}
